import { useEffect, useState } from "react";
import api, { mediaUrl } from "@/lib/api";
import { Film } from "lucide-react";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/videos")
      .then((r) => setVideos(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="videos-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
      <span className="eyebrow text-copper">Watch &amp; Learn</span>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-tight" style={{ textShadow: "0 2px 18px rgba(0,0,0,0.55)" }}>
        High Achievers Videos
      </h1>
      <p className="mt-4 text-white/85 max-w-2xl" style={{ textShadow: "0 1px 10px rgba(0,0,0,0.5)" }}>
        Honest video reviews straight from the High Achievers Texas team — see the
        product, hear the notes, and shop with confidence.
      </p>

      {loading ? (
        <div data-testid="videos-loading" className="mt-16 text-charcoal/60">
          Loading videos…
        </div>
      ) : videos.length === 0 ? (
        <div
          data-testid="videos-empty"
          className="mt-16 border border-tan/40 bg-sand/60 p-12 text-center"
        >
          <Film className="mx-auto text-copper" size={40} />
          <p className="mt-4 font-serif text-2xl text-navy">No reviews yet</p>
          <p className="mt-2 text-charcoal/70">
            Check back soon — our team is filming fresh strain reviews.
          </p>
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((v) => (
            <article
              key={v.id}
              data-testid={`video-card-${v.id}`}
              className="float-card bg-sand border border-tan/40 overflow-hidden flex flex-col"
            >
              <video
                data-testid={`video-player-${v.id}`}
                src={mediaUrl(v.storage_path)}
                poster={v.thumbnail_url ? mediaUrl(v.thumbnail_url) : undefined}
                controls
                preload="metadata"
                playsInline
                className="w-full aspect-video bg-black object-cover"
              />
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-serif text-xl text-navy leading-snug">{v.title}</h3>
                {v.description && (
                  <p className="mt-2 text-sm text-charcoal/75 leading-relaxed line-clamp-3">
                    {v.description}
                  </p>
                )}
                {v.created_by_name && (
                  <div className="mt-4 text-[10.5px] uppercase tracking-[0.2em] text-charcoal/55">
                    Reviewed by {v.created_by_name}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
